import React, { useState } from "react";
import {
  Box,
  Flex,
  Button,
  IconButton,
  useDisclosure,
  Stack,
  Image,
  HStack,
  Link,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { Icon } from "@iconify/react";
import Logo from "../assets/images/drhvac.svg";
import { useNavigate } from "react-router-dom";
import Auth from "../utils/auth";
import "../App.css";

const Navbar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    Auth.logout();
    localStorage.removeItem("token");
    navigate("/login");
  };
  return (
<Box
  position="fixed"
  top={0}
  left={0}
  right={0}
  zIndex={10}
  bg="white"
  boxShadow="0px 10px 20px rgba(0, 0, 0, 0.1), 0px 6px 6px rgba(0, 0, 0, 0.1)"
  py={{ base: 3, md: 4 }}
  px={{ base: 4, md: 10 }}
>

      <Flex h={16} alignItems="center" justifyContent="space-between" mx="auto">
        {/* Logo */}
        <Link href="/" _hover={{ textDecoration: "none" }}>
          <Image src={Logo} alt="Logo" h="80px" />
        </Link>

        {/* Desktop Menu */}
        <HStack as="nav" spacing={4} display={{ base: "none", md: "flex" }}>
          <Link
            className="nav-btn"
            color="#1c4b7e"
            textDecoration="none"
            _hover={{ textDecoration: "none" }}
            _focus={{
              boxShadow: "0 0 0 3px rgba(0, 174, 239, 0.5)",
            }}
            _active={{
              bg: "#00aeef",
              transform: "scale(0.98)",
            }}
            as="a"
            href="/approve"
            paddingX="8"
          >
            Approve
          </Link>
          <Link
            paddingX="8"
            color="#1c4b7e"
            textDecoration="none"
            _hover={{ textDecoration: "none" }}
            className="nav-btn"
            _focus={{
              boxShadow: "0 0 0 3px rgba(0, 174, 239, 0.5)",
            }}
            _active={{
              bg: "#00aeef",
              transform: "scale(0.98)",
            }}
            as="a"
            href="/rating"
          >
            Send Rating Request
          </Link>
          <Link
            paddingX="8"
            color="#1c4b7e"
            textDecoration="none"
            _hover={{ textDecoration: "none" }}
            className="nav-btn"
            _focus={{
              boxShadow: "0 0 0 3px rgba(0, 174, 239, 0.5)",
            }}
            _active={{
              bg: "#00aeef",
              transform: "scale(0.98)",
            }}
            as="a"
            href="/feedback-list"
          >
            Feedback
          </Link>
          <Link
            paddingX="8"
            color="#1c4b7e"
            _focus={{
              boxShadow: "0 0 0 3px rgba(0, 174, 239, 0.5)",
            }}
            _active={{
              bg: "#00aeef",
              transform: "scale(0.98)",
            }}
            as="a"
            href="/emails"
            className="nav-btn"
            textDecoration="none"
            _hover={{ textDecoration: "none" }}
          >
            Emails
          </Link>
          <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)}>
            <MenuButton
              as={Button}
              onClick={() => setMenuOpen(!menuOpen)}
              rightIcon={
                <Icon
                  icon="mdi:chevron-down"
                  width="24" // makes the caret larger
                  height="24" // ensures proportional sizing
                  style={{ fontWeight: "bold" }} // makes it appear thicker
                />
              }
              color="#1c4b7e"
              fontWeight="600"
              _focus={{ boxShadow: "none" }}
            />
            <MenuList>
              <MenuItem onClick={handleLogout}>
                <Button variant="solidBlue">Logout</Button>
              </MenuItem>
            </MenuList>
          </Menu>
        </HStack>

        {/* Mobile Menu Icon */}
        <IconButton
          size="md"
          icon={isOpen ? <Icon icon="mdi:close" /> : <Icon icon="mdi:menu" />}
          aria-label="Open Menu"
          display={{ md: "none" }}
          onClick={isOpen ? onClose : onOpen}
        />
      </Flex>

      {/* Mobile Menu */}
      {isOpen && (
        <Box pb={4} display={{ md: "none" }}>
          <Stack as="nav" spacing={4}>
            <Link
              color="#1c4b7e"
              _focus={{
                boxShadow: "0 0 0 3px rgba(0, 174, 239, 0.5)",
              }}
              _active={{
                bg: "#00aeef",
                transform: "scale(0.98)",
              }}
              as="a"
              href="/approve"
            >
              Approve{" "}
            </Link>
            <Link
              color="#1c4b7e"
              _focus={{
                boxShadow: "0 0 0 3px rgba(0, 174, 239, 0.5)",
              }}
              _active={{
                bg: "#00aeef",
                transform: "scale(0.98)",
              }}
              as="a"
              href="/rating"
            >
              Send Rating Request
            </Link>
            <Link
              color="#1c4b7e"
              _focus={{
                boxShadow: "0 0 0 3px rgba(0, 174, 239, 0.5)",
              }}
              _active={{
                bg: "#00aeef",
                transform: "scale(0.98)",
              }}
              as="a"
              href="/feedback-list"
            >
              Feedback
            </Link>
            <Link
              color="#1c4b7e"
              _focus={{
                boxShadow: "0 0 0 3px rgba(0, 174, 239, 0.5)",
              }}
              _active={{
                bg: "#00aeef",
                transform: "scale(0.98)",
              }}
              as="a"
              href="/emails"
            >
              Emails
            </Link>
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default Navbar;
